import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import ApiCommonContent from "../../services/GenericContent";
import Myprofile, { MyProfile } from "../../components/MyProfile";
import "./styles.scss";
import { CommonContent, ContentKey } from "../../types/Types";
import UserSession from "../../services/UserSession";

const MyProfilePage = () => {
  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  const [profile, setProfile] = React.useState<MyProfile | undefined>(
    undefined
  );

  useEffect(() => {
    if (!commonContent) {
      ApiCommonContent.getContent().then((content) => {
        setCommonContent(content);
      });
    }
  });

  useEffect(() => {
    if (!profile) {
      UserSession.getSession()
        .then((user) => {
          if (user) {
            const profile: MyProfile = {
              name: user.name,
              avatar: user.profileUrl,
              position: 0,
              points: user.points,
              ranking: user.ranking,
              country: user.country,
              countryCode: user.countryCode,
            };
            setProfile(profile);
          }
        })
        .catch((e) => console.error(e));
    }
  }, [profile]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container className="containerWhite" maxWidth="md">
        <AppBar position="static">
          <Toolbar className="toolBarBlue">
            <IconButton
              onClick={() => {
                window.history.back();
              }}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {ApiCommonContent.getKeyValue(
                commonContent,
                ContentKey.MY_PROFILE
              )}
            </Typography>
          </Toolbar>
        </AppBar>
        {profile && commonContent && <Myprofile content={commonContent} profile={profile} />}
      </Container>
    </React.Fragment>
  );
};

export default MyProfilePage;
